<template>
  <div class="wrap">
    <van-sticky>
      <van-nav-bar @click-left="onClickLeft" left-arrow :safe-area-inset-top="true" title="基础信息" />
    </van-sticky>
    <!-- 根据不同type，选择不同信息完善 -->
    <!-- 用户信息 -->
    <div v-if="testingVO.type.key == 'User'" class="block">
      <!-- 当前信息 -->
      <div class="font-bigger">基础信息</div>
      <UserInfoForm :disabled="disabled" :data="userInfo" @submit="submitUserInfo" buttonLabel="下一步" class="mt10">
        <!-- 用户协议 -->
        <div class="agree-content">
          <van-checkbox v-model="agree" shape="square" checked-color="#FB993A" />
          <div @click="toRichText('user_agreement')">{{ userAgreement.name }}</div>
        </div>
      </UserInfoForm>
    </div>
    <!-- 档案信息 -->
    <div v-if="testingVO.type.key == 'Student'" class="block">
      <div v-if="!disabled  || testingAmount == 0" class="font-bigger">选择档案</div>
      <!-- 档案列表 -->
      <div v-if="!disabled || testingAmount == 0" class="mt10">
        <van-radio-group v-model="studentId">
          <van-cell-group v-for="(student,index) in studentList" :key="index">
            <van-cell :title="student.name" clickable @click="selectStudent(student)">
              <template #right-icon>
                <van-radio :name="student.id" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
      </div>
      <!-- 当前信息 -->
      <div class="font-bigger mt40">基础信息</div>
      <StudentBaseForm :disabled="disabled" :testingAmount="testingAmount" :data="studentInfo" @submit="submitStudentInfo" buttonLabel="下一步" class="mt10">
        <!-- 用户协议 -->
        <div class="agree-content">
          <van-checkbox v-model="agree" shape="square" checked-color="#FB993A" />
          <div @click="toRichText('user_agreement')">{{ userAgreement.name }}</div>
        </div>
      </StudentBaseForm>
    </div>
    <!-- 协议查看 -->
    <Agree ref="Agree" />
  </div>
</template>
<script>
import { fetchPageView } from "../../../../api/student"
import Agree from "../../../../components/Agree"
import { Toast } from 'vant'
import { detail } from '../../../../api/testing'
import UserInfoForm from '@/components/UserInfo'
import { fetchByCode } from '../../../../api/rich-text'
import { fetchUserInfo } from '../../../../api/user'
import { fetchRecord, savePO } from '../../../../api/testing-record'
import StudentBaseForm from '@/components/StudentBase'
export default {
  data() {
    return {
      experientialFlag: false,
      testingAmount: 0,
      month: '',
      disabled: false,
      agree: false,
      userAgreement: {},
      userInfo: {},
      studentInfo: {},
      studentId: null,
      testingRecordId: null,
      studentList: [],
      testingVO: {
        type: {
          key: ''
        }
      },
      testingId: null
    }
  },
  components: {
    Agree,
    UserInfoForm,
    StudentBaseForm
  },
  created() {
    this.init()
  },
  watch: {
    $route() {
      this.init()
    }
  },
  methods: {
    onClickLeft() {
      history.back()
    },
    selectStudent(student) {
      this.studentId = student.id
      // 刷新信息
      this.studentInfo = student
    },
    submitUserInfo(data) {
      if (!this.agree) {
        Toast('请同意' + this.userAgreement.name)
        return false
      }
      if (!this.disabled) {
        // 提交，可能创建或更新
        localStorage.setItem('state', data.state.key)
        Toast.loading({
          message: '加载中...',
          forbidClick: true,
        })
        console.info(data.type)
        savePO({
          userAuthPO: {
            ...data,
            height: data.height ? data.height : '60',
            weight: data.weight ? data.weight : '5',
            type: data.type ? data.type : 'None'
          },
          testingRecordId: this.testingRecordId
        }).then(res => {
          Toast.clear()
          this.testingRecordId = res
          localStorage.setItem('TestingRecordId', this.testingRecordId)
          this.fillData(data)
          // 去主页
          setTimeout(() => {
            this.toMain()
          }, 300)
        })
      } else {
        this.toMain()
      }
    },
    submitStudentInfo(data) {
      this.fillMonth(data.birth)
      if (!this.agree) {
        Toast('请同意' + this.userAgreement.name)
        return false
      }
      if (!this.disabled) {
        Toast.loading({
          message: '加载中...',
          forbidClick: true,
        })
        savePO({
          studentBasePO: data,
          testingRecordId: this.testingRecordId
        }).then(res => {
          Toast.clear()
          this.testingRecordId = res
          localStorage.setItem('TestingRecordId', this.testingRecordId)
          // 去主页
          setTimeout(() => {
            this.toMain()
          }, 300)
        })
      } else {
        this.toMain()
      }
    },
    toMain() {
      this.$router.push({
        path: '/testing-main',
        query: {
          month: this.month ? this.month : 0,
          sex: this.sex,
          disabled: this.disabled,
          testingId: this.testingId,
          testingRecordId: this.testingRecordId
        }
      })
    },
    toRichText(code) {
      this.$refs['Agree'].show(code)
    },
    fillData(res) {
      this.userInfo = res
      this.studentInfo = res
      if (!res.state) {
        this.userInfo.state = {}
      } else {
        localStorage.setItem('state', res.state.key)
      }
      if (!res.type) {
        this.userInfo.type = {
          key: ''
        }
      }
      if (!res.sex) {
        this.userInfo.sex = {}
        this.studentInfo.res = {}
      } else {
        this.sex = res.sex.key
      }
    },
    fillMonth(birth) {
      birth = birth.replaceAll('-', '/')
      // 月份
      let curDate = new Date();
      let curY = curDate.getFullYear();
      let curM = curDate.getMonth() + 1;
      let curD = curDate.getDate();
      let curBirth = new Date(birth);
      let birthY = parseInt(curBirth.getFullYear());
      let birthM = parseInt(curBirth.getMonth());
      let birthD = parseInt(curBirth.getDate());
      this.month = (curY - birthY - 1) * 12 + curM + (12 - birthM) - 1;
      if (birthD > curD) {
        this.month--
      }
      // if (this.month > 216) {
      //   Toast('孩子月份不能大于216个月')
      //   return
      // }
      localStorage.setItem('month', this.month)
    },
    async init() {
      this.testingId = this.$route.query.testingId
      this.testingRecordId = this.$route.query.testingRecordId
      localStorage.setItem('TestingRecordId', this.testingRecordId)
      if (!this.testingId) {
        Toast('参数有误')
        return false
      }
      if (this.$route.query.experientialFlag) {
        this.experientialFlag = this.$route.query.experientialFlag
      }
      // 加载分析详情
      await detail({
        testingId: this.testingId
      }).then(res => {
        this.testingVO = res
      })
      // 加载用户协议
      await fetchByCode('user_agreement').then(res => {
        this.userAgreement = res
      })
      // 记载记录信息
      await fetchRecord({
        testingId: this.testingId,
        testingRecordId: this.testingRecordId,
        experientialFlag: this.experientialFlag
      }).then(res => {
        this.testingAmount = res.amount
        this.testingRecordId = res.id
        localStorage.setItem('TestingRecordId', res.id)
        if (res.state.key == 'ToBePaid') {
          // 去支付
        }
        // 根据类型，查询不同信息
        if (this.testingVO.type.key == 'User') {
          if (res.userAuthPO && res.userAuthPO.userId) {
            this.fillData(res.userAuthPO)
          } else {
            // 加载用户信息
            fetchUserInfo().then(res => {
              this.fillData(res)
            })
          }
        }
        if (this.testingVO.type.key == 'Student') {
          // 加载档案列表
          fetchPageView({
            pageSize: 100
          }).then(res => {
            this.studentList = res.content
          })
          if (res.studentBasePO) {
            if (res.studentBasePO.id) {
              this.studentId = res.studentBasePO.id
            }
            this.fillData(res.studentBasePO)
            this.fillMonth(res.studentBasePO.birth)
          }
        }
        if (res.state.key == 'Ing') {
          this.disabled = false
          localStorage.setItem('disabled', 'false')
        } else {
          this.disabled = true
          localStorage.setItem('disabled', 'true')
        }
      })
    }
  }
};
</script>
<style lang="less" scoped>
@import url('../../../../assets/css/style.css');
.block {
  margin-top: 40px;
  padding: 0 40px;
}
.agree-content {
  display: flex;
  flex-direction: row;
  margin-top: 24px;
  padding: 0 16px;
  div {
    font-size: .38rem;
    color: rgb(65, 163, 243)
  };
}
</style>